import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translatePvImmersionStatus',
})
export class TranslatePvImmersionStatusPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.PV_IMMERSION_STATUS[value]) {
      return this.translateService.instant(
        this.customTranslationsService.PV_IMMERSION_STATUS[value] ?? value
      );
    }

    return value;
  }
}
